import { TailSpin } from "react-loader-spinner"

const LoadingImage = () => {
  return (
    <div className="loading-image">
<TailSpin
  visible={true}
  height="20"
  width="20"
  color="goldenrod"
  ariaLabel="tail-spin-loading"
  radius="1"
  wrapperStyle={{}}
  wrapperClass=""
  />
    </div>
  )
}

export default LoadingImage
